import { useState } from "react";

export default function CampoLogin({ onChange }) {
  const [valor, setValor] = useState("");
  const [erro, setErro] = useState("");
  
  function validarIdentificador(input) {
    const apenasNumeros = /^\d+$/;
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (apenasNumeros.test(input)) {
        return input.length >= 10
        ? { tipo: "telefone", valido: true }
        : { tipo: "telefone", valido: false };
    }

    if (regexEmail.test(input)) {
        return { tipo: "email", valido: true };
    }

    return { tipo: null, valido: false };
  }

  function handleChange(e) {
    const input = e.target.value.trim();
    setValor(input);

    setErro("");
    if (input.length < 10) {
        return;
    }

    const resultado = validarIdentificador(input);

    if (!resultado.valido) {
      setErro("Digite um e-mail ou telefone válido");
      onChange?.({ tipo: null, valor: "" });
    } else {
      setErro("");
      onChange?.({ tipo: resultado.tipo, valor: input });
    }
  }

  return (
    <div>
      <input
        type="text"
        value={valor}
        onChange={handleChange}
        placeholder="Digite seu e-mail ou telefone"
        className={erro ? "input-invalid" : ""}
      />
      {erro && <small className="input-error">{erro}</small>}
    </div>
  );
}
